import React, { useState, useEffect } from "react";
import { Button } from "primereact/button";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { FilterMatchMode } from "primereact/api";
import LoadingOverlay from "react-loading-overlay";
import { Triangle } from "react-loader-spinner";
import { InputText } from "primereact/inputtext";
import { handleGetRequest } from "../../services/GetTemplate";
import { useDispatch } from "react-redux";
import { confirmDialog } from "primereact/confirmdialog";
import { useHistory } from "react-router-dom";
import { SplitButton } from "primereact/splitbutton";
import { handleDeleteRequest } from "../../services/DeleteTemplate";
import { Tag } from "primereact/tag";

const ManagePromocode = () => {

    const history = useHistory()
    const dispatch = useDispatch()

    const [isActive, setIsActive] = useState(false)
    const [allPromocodes, setAllPromocodes] = useState([]);
    const [acceptButtonClass, setAcceptButtonClass] = useState('p-button-danger');

    const [globalFilterValue, setGlobalFilterValue] = useState("");
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters["global"].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const actionTemplate = (rowData) => {
        const items = [
            {
                label: 'Edit',
                command: () => handleEditPromocode(rowData),
            },
            {
                label: 'Delete',
                command: () => confirm(rowData),
            },
        ];
        return (
            <div className="">
                <SplitButton label="" model={items} />
            </div>
        );
    };

    const confirm = (rowData) => {
        confirmDialog({
            message: 'Are you sure you want to delete this Promocode?',
            header: 'Confirmation',
            icon: 'pi pi-exclamation-triangle',
            acceptClassName: acceptButtonClass,
            acceptLabel: 'Yes',
            accept: () => {
                handleDeletePromocode(rowData);
            },
            reject: () => {
                return null;
            },
        });
    };

    const handleDeletePromocode = async (rowData) => {
        setIsActive(true);
        const response = await dispatch(handleDeleteRequest(`/promocode/${rowData?._id}`, true, true));
        if (response?.status === 'success' || response?.statusCode === 200) {
            await getPromocodeList();
        }
        setIsActive(false);
    };

    const handleEditPromocode = (rowData) => {
        const item = true;
        history.push({
            pathname: './addeditpromocode',
            state: {
                isEditable: item,
                rowData: rowData,
            }
        });
    };

    //Get Promocode List
    const getPromocodeList = async () => {
        setIsActive(true);
        const response = await dispatch(handleGetRequest(`/promocode/getAll`, true));
        if (response?.status === 'success' || response?.statusCode === 200) {
            setAllPromocodes(response?.data || []);
        }
        setIsActive(false);
    };

    useEffect(() => {
        getPromocodeList();
    }, [])

    const dateTemplate = (rowData) => {
        if (rowData?.createdAt) {
            const date = new Date(rowData.createdAt);
            return date.toLocaleDateString('en-US', { 
                year: 'numeric', 
                month: 'short', 
                day: 'numeric' 
            });
        }
        return 'N/A';
    };

    const validUntilTemplate = (rowData) => {
        if (rowData?.validUntil) {
            const date = new Date(rowData.validUntil);
            const now = new Date();
            const isValid = date > now;
            
            return (
                <div>
                    <div>{date.toLocaleDateString('en-US', { 
                        year: 'numeric', 
                        month: 'short', 
                        day: 'numeric' 
                    })}</div>
                    <Tag 
                        value={isValid ? 'Valid' : 'Expired'} 
                        severity={isValid ? 'success' : 'danger'} 
                        style={{ fontSize: '0.75em', marginTop: '4px' }}
                    />
                </div>
            );
        }
        return 'N/A';
    };

    const discountTemplate = (rowData) => {
        return `${rowData?.discountPercentage || 0}%`;
    };

    const statusTemplate = (rowData) => {
        const isUsed = rowData?.isUsed || false;
        return (
            <Tag 
                value={isUsed ? 'Used' : 'Available'} 
                severity={isUsed ? 'warning' : 'success'} 
            />
        );
    };

    return (
        <>
            <div className="flex flex-column align-items-start md:flex-row  md:justify-content-between md:align-items-center ">
                <h4 className="mb-0" style={{ fontWeight: '600', letterSpacing: '0.5px', color: 'black' }}>
                    Promocodes Management
                </h4>
                <div className="flex flex-column align-items-start  md:flex-row md:align-items-center">
                    <span className="p-input-icon-left mr-3 resp-margin my-3 md:my-0">
                        <i className="pi pi-search" />
                        <InputText
                            placeholder="Search"
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            className="search-input"
                        />
                    </span>
                    {/* <div className="">
                        <Button
                            label="Add New Promocode"
                            className="Add__New-Button ml-3"
                            icon="pi pi-plus"
                            onClick={() => {
                                const item = false;
                                history.push({
                                    pathname: './addeditpromocode',
                                    state: {
                                        isEditable: item,
                                    }
                                });
                            }}
                        />
                    </div> */}
                </div>
            </div>

            <div className="card mt-3">
                <LoadingOverlay
                    active={isActive}
                    spinner={<Triangle
                        height="120"
                        width="120"
                        color="#dc2626"
                        ariaLabel="triangle-loading"
                        wrapperStyle={{}}
                        wrapperClassName=""
                        visible={true}
                    />}
                    styles={{
                        overlay: (base) => ({
                            ...base,
                            background: 'rgb(38 41 51 / 78%)',
                        })
                    }}
                >
                    <DataTable
                        responsive={true}
                        filters={filters}
                        globalFilterFields={[
                            "code",
                            "userEmail",
                            "discountPercentage",
                        ]}
                        responsiveLayout="scroll"
                        stripedRows
                        paginator
                        rows={20}
                        value={allPromocodes}
                        emptyMessage="No promocodes found"
                        paginatorClassName="custom-paginator"
                        paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                        rowsPerPageOptions={[10, 20, 30, 40, 50]}
                    >
                        <Column sortable field='code' body={(rowData) => <strong style={{ color: '#dc2626' }}>{rowData?.code || 'N/A'}</strong>} header="Promocode"></Column>
                        <Column sortable field='userEmail' body={(rowData) => rowData?.userEmail || 'N/A'} header="User Email"></Column>
                        <Column sortable field='discountPercentage' body={discountTemplate} header="Discount"></Column>
                        <Column field='validUntil' body={validUntilTemplate} header="Valid Until"></Column>
                        <Column field='isUsed' body={statusTemplate} header="Status"></Column>
                        {allPromocodes.some(promo => promo?.usedAt) && (
                            <Column field='usedAt' body={(rowData) => rowData?.usedAt ? new Date(rowData.usedAt).toLocaleDateString() : '-'} header="Used At"></Column>
                        )}
                        {allPromocodes.some(promo => promo?.orderId) && (
                            <Column field='orderId' body={(rowData) => rowData?.orderId || '-'} header="Order ID"></Column>
                        )}
                        <Column field='createdAt' body={dateTemplate} header="Created Date"></Column>
                        <Column header="Action" body={actionTemplate} />
                    </DataTable>
                </LoadingOverlay>
            </div>
        </>
    );
};

export default ManagePromocode;

